import React from 'react';
import profile from '../assets/profile.jpg';
import aboutArt from '../assets/cards/about.svg';
import projectsArt from '../assets/cards/projects.svg';
import experienceArt from '../assets/cards/experience.svg';
import skillsArt from '../assets/cards/skills.svg';
import contactArt from '../assets/cards/contact.svg';

// ── Combatants ──────────────────────────────────────────────────────────────
// Boss maxHp = sum of every card's damage, so visiting every section defeats it.
export const ENEMY = {
  name: 'THE MAINFRAME',
  subtitle: 'Core Guardian · Elite',
  maxHp: 100,
  intent: 'FIREWALL',
  flavor: 'The lair’s last guardian. It runs on everything you haven’t shipped.',
};

export const PLAYER = {
  name: 'CJ STANCIN',
  title: 'Operator',
  maxHp: 100,
  avatar: profile,
};

// Energy = jobs worked. Total card cost (4) is exactly affordable.
export const ENERGY = { value: 4, max: 4, note: '1 per job worked' };

// ── Room metadata (each section is reskinned as a Slay-the-Spire room) ──────────
export const ROOM_META = {
  rest: { label: 'REST SITE', icon: 'flame' },
  treasure: { label: 'TREASURE', icon: 'chest' },
  elite: { label: 'ELITE', icon: 'skull' },
  shop: { label: 'SHOP', icon: 'shop' },
  event: { label: 'UNKNOWN', icon: 'terminal' },
};

// ── The deck. One typed object per section → trivially add a 6th+. ───────────────
export const CARDS = [
  {
    id: 'about',
    name: 'IDENTITY.CORE',
    type: 'attack',
    cost: 0,
    damage: 20,
    rarity: 'elite',
    room: 'rest',
    route: '/about',
    section: 'About',
    ability: 'Deal 20 damage. Reveal the operator — every directive that drives him.',
    flavor: 'Know thy enemy. Know thyself first.',
    enabled: true,
  },
  {
    id: 'projects',
    name: 'ARSENAL.DEPLOY',
    type: 'attack',
    cost: 2,
    damage: 30,
    rarity: 'rare',
    room: 'treasure',
    route: '/projects',
    section: 'Projects',
    ability: 'Deal 30 damage. Loose every shipped build at once.',
    flavor: 'The whole armory, swung like a hammer.',
    enabled: true,
  },
  {
    id: 'experience',
    name: 'SERVICE.RECORD',
    type: 'attack',
    cost: 1,
    damage: 25,
    rarity: 'rare',
    room: 'elite',
    route: '/experience',
    section: 'Experience',
    ability: 'Deal 25 damage. Strike with every battle already won.',
    flavor: 'Two tours at Raytheon. The scars do the talking.',
    enabled: true,
  },
  {
    id: 'skills',
    name: 'SUBROUTINES',
    type: 'attack',
    cost: 1,
    damage: 15,
    rarity: 'uncommon',
    room: 'shop',
    route: '/experience',
    section: 'Skills',
    ability: 'Deal 15 damage. A volley of mastered skills.',
    flavor: 'Java, Python, C++, React — loosed in one breath.',
    enabled: true,
  },
  {
    id: 'contact',
    name: 'OPEN.CHANNEL',
    type: 'attack',
    cost: 0,
    damage: 10,
    rarity: 'uncommon',
    room: 'event',
    route: '/contact',
    section: 'Contact',
    ability: 'Deal 10 damage. Pierce the firewall and open a channel.',
    flavor: 'One clean line, straight to the core.',
    enabled: true,
  },
];

// ── Card art: painterly illustrations per section ──────────────────────────────
const CARD_ART = {
  about: aboutArt,
  projects: projectsArt,
  experience: experienceArt,
  skills: skillsArt,
  contact: contactArt,
};

export const CardArt = ({ id, className = '' }) => {
  const src = CARD_ART[id];
  if (!src) return <span className={`cardArtImg ${className}`} aria-hidden="true" />;
  return <img className={`cardArtImg ${className}`} src={src} alt="" aria-hidden="true" />;
};
